import statTooltips from "../utils/statTooltips"
import "../styles/headerTooltip.css"

// Wraps a header label and shows a small definition popup on hover,
// if a definition exists in statTooltips. If no definition exists,
// it just renders the label with no extra markup/behavior.
function HeaderTooltip({ label, tooltipKey }) {
  const tooltip = statTooltips[tooltipKey || label]

  if (!tooltip) {
    return <>{label}</>
  }

  return (
    <span className="header-tooltip-wrapper">
      {label}
      <span className="header-tooltip-popup">{tooltip}</span>
    </span>
  )
}

export default HeaderTooltip